import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalContent,
  ModalBody,
  ModalFooter,
  useDisclosure,
} from "@heroui/react";
import UserTable from "./UserTable";
import UserForm from "./UserForm";
import { Spinner } from "@heroui/react";

const Users = () => {
  // const [users, setUsers] = useState(initialUsers);
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    wallet_balance: 0,
    password: "",
    phone: "",
    role: "user",
    status: "1",
  });
  const {
    isOpen: isMessageOpen,
    onOpen: onMessageOpen,
    onOpenChange: onMessageOpenChange,
    onClose: onMessageClose,
  } = useDisclosure();
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("alert");
  const [modalCallback, setModalCallback] = useState(null);
  const [modalAutoCloseMs, setModalAutoCloseMs] = useState(0);

  useEffect(() => {
    if (isMessageOpen && modalType === "alert" && modalAutoCloseMs > 0) {
      const timeoutId = setTimeout(() => {
        if (typeof modalCallback === "function") {
          const maybeFn = modalCallback();
          if (typeof maybeFn === "function") {
            maybeFn();
          }
        }
        if (typeof onMessageClose === "function") {
          onMessageClose();
        }
        setModalAutoCloseMs(0);
      }, modalAutoCloseMs);
      return () => clearTimeout(timeoutId);
    }
  }, [
    isMessageOpen,
    modalType,
    modalAutoCloseMs,
    modalCallback,
    onMessageClose,
  ]);

  const getAdminDashboardUsers = async () => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

    // If user_id is needed, pass it as a query param
    const userId = localStorage.getItem("uid");
    const url = `${process.env.REACT_APP_API_HOST}/admin/getusers?user_id=${userId}`;

    const requestOptions = {
      method: "GET",
      headers: headers,
    };

    fetch(url, requestOptions)
      .then((response) => {
        if (response.status === 401) {
          console.log("Unauthorized access. Please log in again.");
        } else {
          return response.json();
        }
      })
      .then((result) => {
        if (result.data) {
          setUsers(result.data);
        }
      })
      .catch((err) => {
        console.log("Error fetching users:", err);
      });
  };

  useEffect(() => {
    getAdminDashboardUsers();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newUser = {
      id: users.length + 1,
      ...formData,
    };
    setUsers((prev) => [...prev, newUser]);
    setShowForm(false);
    setFormData({
      name: "",
      email: "",
      phone: "",
      role: "user",
      status: "active",
    });
  };

  const handleEdit = (user) => {
    // setFormData(user);
    // setFormData({
    //   name: "",
    //   email: "",
    //   phone: "",
    //   role: "user",
    //   status: 0,
    // });
    // console.log("Editing user:", user.status.data[0]);
    // setFormData({
    //   name: user.name,
    //   email: user.email,
    //   phone: user.phone,
    //   role: user.role==="Client" ? "user" : user.role==="Admin" ? "admin" : "",
    //   status: user.status.data[0] === 1 ? 1 : user.status.data[0] === 0 ? 0 : "",
    // });
    // setShowForm(true);

    setShowForm(true);
    setTimeout(() => {
      const mainContainer = document.querySelector("main");
      if (mainContainer) {
        mainContainer.scrollTo({ top: 0, behavior: "smooth" });
      }
    }, 0);

    const roleMap = {
      Client: "user",
      Admin: "admin",
      Operator: "operator",
    };

    const roleValue = roleMap[user.role] || "";

    const statusValue = user.status?.data?.[0] === 1 ? 1 : 0;

    setFormData({
      user_id: user.id,
      name: user.name || "",
      username: user.username || "",
      wallet_balance: user.wallet_balance || 0,
      password: user.password || "",
      // email: user.email || "",
      phone: user.phone || "",
      role: roleValue,
      status: statusValue,
    });

    console.log("Editing user:", user);
    setShowForm(true);
  };

  const handleDelete = (id) => {
    setModalMessage("Are you sure you want to delete this user?");
    setModalType("confirm");
    setModalCallback(() => () => {
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + localStorage.getItem("jwt"));

      const urlencoded = {
        user_id: localStorage.getItem("uid"),
        delete_user_id: id,
      };

      let requestOptions = {
        method: "POST",
        headers: headers,
        body: JSON.stringify(urlencoded),
      };

      fetch(process.env.REACT_APP_API_HOST + "/delete/user", requestOptions)
        .then((response) => {
          if (response.status === 401) {
            console.log("Unauthorized access. Please log in again.");
          } else {
            return response.json();
          }
        })
        .then((result) => {
          if (result?.success === true) {
            setModalMessage("User deleted successfully!");
            setModalType("alert");
            setModalCallback(() => () => {
              getAdminDashboardUsers();
            });
            setModalAutoCloseMs(1000);
            onMessageOpen();
          } else {
            setModalMessage(result?.message || "Failed to delete user.");
            setModalType("alert");
            setModalCallback(null);
            onMessageOpen();
          }
        })
        .catch((err) => {
          console.log("Error deleting user:", err);
          setModalMessage("Error deleting user.");
          setModalType("alert");
          setModalCallback(null);
          onMessageOpen();
        });
    });
    onMessageOpen();
  };
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    // Show spinner for 1 second on mount
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="absolute inset-0 flex items-center justify-center">
        <Spinner size="lg" variant="spinner" color="warning" />
        {/* <img src="/img/Pinwheel.gif" alt="Loading..." className="w-16 h-16" /> */}
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h2 className="text-2xl font-semibold text-gray-900">Users</h2>
        <Button
          color="primary"
          className="bg-admin_black text-white"
          onClick={() => {
            setShowForm(!showForm);
            setFormData({
              name: "",
              status: 1,
              wallet_balance: 0,
              password: "",
              email: "",
              phone: "",
              role: "user",
            });
          }}
        >
          {showForm ? "Cancel" : "Add User"}
        </Button>
      </div>

      {showForm && (
        <UserForm
          formData={formData}
          setFormData={setFormData}
          onSubmit={handleSubmit}
          onCancel={() => setShowForm(false)}
          getAdminDashboardUsers={getAdminDashboardUsers}
          setShowForm={setShowForm}
        />
      )}
      <UserTable users={users} onEdit={handleEdit} onDelete={handleDelete} />

      <Modal
        isOpen={isMessageOpen}
        onOpenChange={onMessageOpenChange}
        classNames={{
          backdrop: "bg-black/35",
          wrapper: "flex items-center justify-center min-h-screen",
        }}
      >
        <ModalContent>
          {(onClose) => (
            <>
              {modalType === "confirm" && (
                <>
                  <ModalBody className="flex items-start justify-center min-h-[60px]">
                    <p className="text-center font-semibold">{modalMessage}</p>
                  </ModalBody>
                  <ModalFooter className="-mt-4">
                    <Button color="danger" variant="light" onPress={onClose}>
                      Cancel
                    </Button>
                    <Button
                      color="primary"
                      onPress={() => {
                        if (typeof modalCallback === "function") {
                          const maybeFn = modalCallback();
                          if (typeof maybeFn === "function") {
                            maybeFn();
                          }
                        }
                        onClose();
                      }}
                    >
                      Yes
                    </Button>
                  </ModalFooter>
                </>
              )}

              {modalType === "alert" && (
                <>
                  <ModalBody className="flex items-center justify-center min-h-[80px]">
                    <p className="text-center font-semibold">{modalMessage}</p>
                  </ModalBody>
                </>
              )}
            </>
          )}
        </ModalContent>
      </Modal>
    </div>
  );
};
export default Users;
